const defaultVerified = true;

export const verifiedOrDefault = (verified: boolean | undefined): boolean =>
  verified ?? defaultVerified;

export const mapToVerifiedDto = (
  id: string | undefined,
  verified: boolean | undefined,
): boolean => (id ? verifiedOrDefault(verified) : defaultVerified);
